/* eslint-disable react/prop-types */
import classes from "./finance.module.scss";
import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewOne from "@/composed-views/composed-view-one";
import ComposedViewSeven from "@/composed-views/composed-view-seven";
import ComposedViewFive from "@/composed-views/composed-view-five";
import ComposedViewInfiniteCarousel from "@/composed-views/composed-view-infinite-carousel";
import CardViewService from "@/composed-views/card-view-service";
import { FACILITATIONS } from "@/static-texts/facilitations";
function Finance({ content }) {
  return (
    <Flex
      align="flex-start"
      className={classes.finance}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={content.header.header}
        title={content.header.title}
        subTitle={content.header.subTitle}
      />

      <ComposedViewOne
        title={content.whatsIs.title}
        content={content.whatsIs.content}
        image={content.whatsIs.image}
        header={content.whatsIs.header}
        button={content.whatsIs.button}
      />

      <ComposedViewSeven
        title={content.concessions.title}
        content={content.concessions.content}
        steps={content.concessions.steps}
      />

      <ComposedViewInfiniteCarousel
        title={content.services.title}
        subTitle={content.services.subTitle}
        items={Object.keys(FACILITATIONS).map((key) => FACILITATIONS[key])}
        itemType={<CardViewService size={"md"} />}
      />

      <ComposedViewFive
        title={content.help.title}
        content={content.help.content}
        button={content.help.button}
        className={classes.help}
      />
    </Flex>
  );
}

export default Finance;
